import React from 'react';
import { styled } from '@linaria/react';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { Box } from '@daedalus/atlas/helpers/Box';
import { Icon } from '@daedalus/atlas/Icon';
import { Text } from '@daedalus/atlas/Text';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { OfferLayout } from '@daedalus/shared/src/search/OfferLayout';
const _exp = /*#__PURE__*/() => Text;
const SeeAllWrapper = /*#__PURE__*/styled(_exp())({
  name: "SeeAllWrapper",
  class: "spdz6oh",
  propsAsIs: true
});
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w6ahzfc",
  propsAsIs: false
});
interface Props {
  onClick: () => void;
}
export const MoreDealsButtonVertical: React.FC<Props> = ({
  onClick
}) => {
  // Added as part of 70766997-desktop-hotel-card-secondary-offers
  const {
    isDesktop
  } = useDeviceLayout();
  return <Wrapper onClick={onClick}>
      <OfferLayout variant={isDesktop ? 'SecondaryInline' : 'SecondaryDefault'} // Added as part of 70766997-desktop-hotel-card-secondary-offers
    priceComponent={<SeeAllWrapper variant="labelS">
            {!isDesktop && <FormattedMessageWrapper id="hotelCard.seeAll" defaultMessage="See all" />}
            <Box data-id="ArrowIcon" hasMirror marginLeft="s200" color="content.neutral.c600">
              <Icon name="ChevronRight" size="sm" />
            </Box>
          </SeeAllWrapper>} providerLogoComponent={<Text variant={isDesktop ? 'labelXS' : 'labelS'}
    // Added as part of 70766997-desktop-hotel-card-secondary-offers
    className="__moreDeals">
            <FormattedMessageWrapper id="hotelCard.moreDeals" defaultMessage="More Deals" />
          </Text>} />
    </Wrapper>;
};

require("./MoreDealsButtonVertical.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./MoreDealsButtonVertical.tsx");